export default "__VITE_ASSET__B_Jslk6a__"